import { render, staticRenderFns } from "./RegDetails.vue?vue&type=template&id=ca86c574&scoped=true"
import script from "./RegDetails.vue?vue&type=script&lang=js"
export * from "./RegDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca86c574",
  null
  
)

export default component.exports